import React from 'react';
import classNames from 'classnames';

import questionService from '../../services/QuestionService';
import utilsService from '../../services/UtilsService';

import '../../../css/CustomHtmlOption.scss';

import FeedbackIcon from '../FeedbackIcon';
import HtmlComponent from '../HtmlComponent';

const CustomHtmlOption = (props) => {
  const { data, innerProps, innerRef, isFocused } = props;
  const isMulti = props.isMulti || props.selectProps?.isMulti;

  innerProps.tabIndex = 0;

  if (!isMulti) {
    innerProps.onMouseOver = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
    innerProps.onMouseMove = (event) => {
      event.preventDefault();
      event.stopPropagation();
    };
  }

  let dataLabel = data.viewLabel;
  if (dataLabel?.startsWith?.('<menclose')) {
    dataLabel = `<math>${dataLabel}</math>`;
  }
  const titleText = utilsService.stripTagsAndEntities(dataLabel);
  const showAnswerFeedback = isMulti && !!props.selectProps?.showAnswerFeedback;
  const answerId = questionService.getPickAnswerId(data) || data?.originalData?.id || data?.value;
  return (
    <div ref={innerRef} className={classNames({
      'custom-html-dropdown-option': true,
      'is-focused': !isMulti && isFocused,
      'is-multi': isMulti,
      'is-selected': props.isSelected
    })} title={titleText} {...innerProps}>
      {isMulti && (
        <span
          aria-hidden='true'
          className={classNames('custom-html-dropdown-option-checkbox', {
            checked: props.isSelected
          })} />
      )}
      <HtmlComponent htmlStr={dataLabel} />
      {showAnswerFeedback && (
        <FeedbackIcon
          answerId={answerId}
          feedbackIconSvgHeight='16'
          feedbackIconSvgTransform='translate(0, 0)'
          feedbackIconSvgWidth='16'
          lessonElementId={props.selectProps.lessonElementId}
          lessonElementState={props.selectProps.lessonElementState}
          model={props.selectProps.model}
          promptId={data?.dataId} />
      )}
    </div>
  );
};

export default CustomHtmlOption;
